import { render } from "./Wrapper.vue?vue&type=template&id=1ee5faae&scoped=true"
import script from "./Wrapper.vue?vue&type=script&lang=js"
export * from "./Wrapper.vue?vue&type=script&lang=js"

import "./Wrapper.vue?vue&type=style&index=0&id=1ee5faae&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1ee5faae"

export default script